import { useState } from "react";
import RichTextArea from "../RichTextArea/RichTextArea";
import s from "./TabContent.module.scss";

const TabContent = ({ heading, tabs }) => {
    const [activeTab, setActiveTab] = useState(0);
    // console.log({tabs});
    return <div className={s.root}>
        <div className={s.container}>
            <h2 className={s.heading}>{heading}</h2>
            <div className={s.tabs}>
                {tabs.map((tab, index) => (
                    <button key={index} className={`${s.tab} ${activeTab === index ? s.active : ""}`} onClick={() => setActiveTab(index)}>
                        {tab?.fields?.title}
                    </button>
                ))}
            </div>
            <div className={s.content}>
                {tabs[activeTab]?.fields?.content?.map((c, i) => <div key={i} className={c?.fields?.enBgColor == 'true' ? s.enBgColor : ""}>
                    {!!c?.fields?.heading && <h2 className={s.sectionHeading}>{c?.fields?.heading}</h2>}
                    <RichTextArea className={s.richtext} textblob={c?.fields?.html}/>
                </div>)}
            </div>
        </div>
    </div>
}

export default TabContent;